<template>
	<div class="page">
		<header>
			<h1>
				Typologie
				<br />de Terrain
			</h1>
		</header>
		<article>
			<div class="gauche">
				<h2>Plat</h2>
				<div
					:class="terrain == 'Plat' ? 'selected option' : 'option'"
					id="terrain_plat"
					@click="handleTerrain('terrain_plat', 'Plat')"
				>
					<img src="../assets/01-terrainplat.png" />
				</div>
			</div>
			<div class="droite">
				<h2>En pente</h2>
				<div
					:class="terrain == 'En pente' ? 'selected option' : 'option'"
					id="terrain_pente"
					@click="handleTerrain('terrain_pente', 'En pente')"
				>
					<img src="../assets/01-terrainpente.png" />
				</div>
			</div>
		</article>
		<footer>
			<router-link to="/" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
			<router-link v-if="ready || terrain.length > 1" to="/architecture" class="button medium">
				Choix de l'architecture
				<i class="fa fa-angle-right"></i>
			</router-link>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "Typologie",
		components: {},
		data() {
			return {
				ready: false
			};
		},
		computed: {
			terrain() {
				return this.$store.state.terrain;
			}
		},
		methods: {
			handleTerrain(e, a) {
				this.ready = true;
				var options = document.querySelectorAll(".option");
				var element = document.getElementById(e);
				options.forEach(el => {
					el.classList.remove("selected");
				});
				element.classList.add("selected");
				this.$store.commit("setTerrain", a);
			}
		},
		mounted() {
			this.$store.commit("setTimer", 60);
		}
	};
</script>

<style lang="less">
</style>